'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { cn } from '@achra/ui/lib/utils';
import type { BudgetStatement, MetricWithoutBudget, SortOptionValue } from '@/modules/finances/types';
import { useInfiniteArray } from '@/modules/shared/hooks/use-infinite-array';
import { BudgetStatementsItem } from './budget-statement-item/budget-statement-item';
interface BudgetStatementsContentProps {
  budgetMetric: MetricWithoutBudget;
  sortOption?: SortOptionValue;
  budgetStatements: BudgetStatement[];
  asSectionContent?: boolean;
}
function BudgetStatementsContent(t0) {
  const $ = _c(15);
  const {
    budgetMetric,
    sortOption,
    budgetStatements,
    asSectionContent: t1
  } = t0;
  const asSectionContent = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      firstPageSize: 10,
      pageSize: 10,
      enabled: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    visibleItems,
    hasMore,
    loadMore
  } = useInfiniteArray(budgetStatements, t2);
  const t3 = hasMore && "gap-6";
  let t4;
  if ($[1] !== t3) {
    t4 = cn("flex h-fit flex-col", t3);
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== asSectionContent || $[4] !== budgetMetric || $[5] !== sortOption || $[6] !== visibleItems) {
    t5 = <BudgetStatementsItem budgetStatements={visibleItems} budgetMetric={budgetMetric} sortOption={sortOption} asSectionContent={asSectionContent} />;
    $[3] = asSectionContent;
    $[4] = budgetMetric;
    $[5] = sortOption;
    $[6] = visibleItems;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== hasMore || $[9] !== loadMore) {
    t6 = hasMore && <Button variant="outline" size="lg" className="w-58 self-center md:mt-0" onClick={loadMore}>Load More</Button>;
    $[8] = hasMore;
    $[9] = loadMore;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <div className={t4}>{t5}{t6}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
export { BudgetStatementsContent };